import $ from 'jquery';
import { getWidth, onResize } from '../utils/window';

export default function founderSection() {
	const $html = $('html');
    const $scroller = $('html, body');

    if($('#content').hasClass('homepage')) {

        const $founder = $('.founder');
        const $message = $founder.find('.founder-message');
        const $image = $founder.find('.founder-image');
        const $video = $founder.find('.founder-video');
        const $info = $founder.find('.founder-info');

        function reSize() {
            let topHeight = 0;
            let bottomHeight = 0;
    
            if(getWidth() > 1220) {
                $message.css('height', '');
                $video.css('height', '');
                $info.css('height', '');

                // console.log($message.outerHeight());
                if($message.outerHeight() > $video.outerHeight()) {
                    topHeight = $message.outerHeight();
                } else {
                    topHeight = $video.outerHeight();
                }
        
                if($image.outerHeight() > $info.outerHeight()) {
                    bottomHeight = $image.outerHeight();
                } else {
                    bottomHeight = $info.outerHeight();
                }
                // $message.css('height', topHeight+'px');
                $video.css('height', topHeight+'px');
                $info.css('height', bottomHeight+'px');
            } else {
                $video.css('height', '');
                $info.css('height', '');
            }
        }

        reSize();

        onResize(()=>{
            reSize();
        });
    }

}



// WEBPACK FOOTER //
// ./source/scripts/sections/founder.js